<script>
import Vue from 'vue';

export default {
  name: 'has-pagination',
  computed: {
    currentVieName () {
      return this.$route.path.replace(/^a-z0-9\-\//gmi, '')
    }
  },
  watch: {
    'paginationMetaData': function (newValue) {
      if (newValue && newValue.last_page && this.currentPage > newValue.last_page ) {
        this.setPage(newValue.last_page, false);
      }
    }
  },
  data () {
    return {
      currentPage: 1,
      paginationMetaData: null
    };
  },
  beforeMount () {
    if (localStorage.getItem('tw-pozyczki-crm-pagination')) {
      let paginationData = JSON.parse(localStorage.getItem('tw-pozyczki-crm-pagination'));

      if (paginationData.view && paginationData.view === this.currentVieName) {
        this.currentPage = paginationData.page;
      } else {
        localStorage.removeItem('tw-pozyczki-crm-pagination');
      }
    }
  },
  mounted () {
    this.$bus.$on('pagination-page-changed', this.setPage);
    this.$bus.$on('pagination-reset', this.resetPagination);
  },
  methods: {
    setPage (page, fetchData = true) {
      Vue.set(this, 'currentPage', page);

      if (fetchData) {
        this.debouncedLoadFilteredData();
      }

      this.$nextTick(() => {
        localStorage.setItem('tw-pozyczki-crm-pagination', JSON.stringify({
          view: this.currentVieName,
          page: this.currentPage
        }));
      })
    },
    resetPagination () {
      this.currentPage = 1;

      localStorage.setItem('tw-pozyczki-crm-pagination', JSON.stringify({
        view: this.currentVieName,
        page: 1
      }));
      this.debouncedLoadFilteredData();
    }
  },
  beforeDestroy () {
    this.$bus.$off('pagination-page-changed', this.setPage);
    this.$bus.$off('pagination-reset', this.resetPagination);
  }
}
</script>
